import {whitelabelling as Whitelabelling} from 'whitelabelling';
import {RegistrationData} from 'model/registrationData';
import {CUSTOM_INPUT_FILE_ADDED} from 'directives/customInputFile';
import * as _ from 'underscore';

const GROUPS = [
    'getting_started',
    'personal_info',
    'professional_info',
    'availability',
    'career_goals',
    'confirm',
    'complete',
    'verify_email',
    'new_program_added',
];

const stepLabelToControllerMap = {
    'getting_started': 'GroupStep_GettingStarted',
    'personal_info': 'GroupStep_PersonalInfo',
    'professional_info': 'GroupStep_ProfessionalInfo',
    'availability': 'GroupStep_Availability',
    'career_goals': 'GroupStep_CareerGoals',
    'confirm': 'GroupStep_Confirm',
    'complete': 'GroupStep_Complete',
    'verify_email': 'GroupStep_VerifyEmail',
    'user_type': 'GroupStep_UserType as ctrl',
    'new_program_added': 'GroupStep_NewProgramAdded',
};

export const RegistrationController = [
    '$scope', '$rootScope', '$window', '$controller', '$routeParams', '$location', 'RegistrationService', 'CustomInputService', '$q',
    function($scope, $rootScope, $window, $controller, $routeParams, $location, RegistrationService, CustomInputService, $q) {
        $scope.whitelabelling = Whitelabelling;

        try {
            //try getting HTTP GET params inside AngularJS app. mentoring.vault.com should be redirected upon finishing registration
            let getParams = (new URLSearchParams($window.location.search));
            if (getParams.get('redirect')) {
                $rootScope.redirectURL = getParams.get('redirect');
            }
        } catch (e) {}

        if (!$routeParams.group) {
            gotoGroup(GROUPS[0]);
        }

        // localStep is which step in this group are we on - it is used to determine which input directives / or
        // messages to show in the template view
        $scope.currentStepGroup = $routeParams.group;
        $scope.localStep = parseInt($routeParams.step || 0);
        $scope.localSubStep = parseInt($routeParams.sub_step || 0);
        $scope.showNext = false;
        $scope.hideNext = false;
        $scope.canChoosePrimaryRole = true;

        // these variables control how the content is centered (min and max margin top on the input area)
        $scope.minInputTop = 40;
        $scope.maxInputTop = 140;

        var view = stepLabelToControllerMap[$scope.currentStepGroup];

        // hasErrors is a function that will return true if any of the inputs in the current step are invalid
        $scope.hasErrors = function() {
            return false;
        };

        $scope.showMissingInputs = function() {
            $scope.$broadcast('showErrors');
        };

        // rather than write this 100 times, I'm putting it here for convenience
        $scope._basicShowNextCondition = function() {
            $scope.showNext = !$scope.hasErrors();
        };

        $scope.customInputFilesToAdd = {};
        $scope.$on(CUSTOM_INPUT_FILE_ADDED, (_, customInputId, files) => {
            $scope.customInputFilesToAdd[customInputId] = files;
        });

        $q.all([
            RegistrationService.getRegistrationData(),
            RegistrationService.getRegistrationSettings(),
            CustomInputService.getCustomInputs(),
        ]).then(function(data) {
            $scope.registrationData = data[0];
            $scope.registrationSettings = data[1];
            $scope.customInputs = data[2];

            $scope.registrationData.wasLoggedIn = false;
            $scope.showPasswordInput = true;
            if (!$scope.registrationData.email && window.firsthand && window.firsthand.preloadEmail) {
                $scope.registrationData.email = window.firsthand.preloadEmail;
            }
            if (window.firsthand) {
                if (window.firsthand.wasLoggedIn) {
                    $scope.registrationData.wasLoggedIn = window.firsthand.wasLoggedIn;
                }
                if (window.firsthand.primaryRole) {
                    $scope.registrationData.primaryRole = window.firsthand.primaryRole;
                    $scope.canChoosePrimaryRole = false;
                }
                if (window.firsthand.showPasswordInput !== undefined) {
                    $scope.showPasswordInput = window.firsthand.showPasswordInput;
                }

                if (window.firsthand.passcodeProvisioning !== undefined) {
                    $scope.registrationData.passcodeProvisioning = window.firsthand.passcodeProvisioning;
                }

                if (window.firsthand.passcode !== undefined) {
                    $scope.registrationData.passcode = window.firsthand.passcode;
                }
            }

            // Handle logic for disallowing Expert / Consumer registration workflow
            var canRegisterExpert = null;
            var canRegisterConsumer = null;

            // Check first if the user has partial role completion:
            if ($scope.registrationData.roleStatus(RegistrationData.ROLE_EXPERT) ===
                RegistrationData.STATUS_INCOMPLETE) {
                // Expert is allowed
                canRegisterExpert = true;
            } else if ($scope.registrationData.roleStatus(RegistrationData.ROLE_EXPERT) ===
                RegistrationData.STATUS_ACTIVE) {
                // If you've completed Expert registration, you cannot re-register as an expert.
                canRegisterExpert = false;
            }

            if ($scope.registrationData.roleStatus(RegistrationData.ROLE_CONSUMER) ===
                RegistrationData.STATUS_INCOMPLETE) {
                // Consumer is allowed
                canRegisterConsumer = true;
            } else if ($scope.registrationData.roleStatus(RegistrationData.ROLE_CONSUMER) ===
                RegistrationData.STATUS_ACTIVE) {
                // If you've completed Consumer registration, you cannot re-register as a consumer.
                canRegisterConsumer = false;
            }

            var canRegisterLogic = function(allowRule, fallback) {
                var affiliation = $scope.registrationData.ssoAffiliation;

                // Logic can be different depending on if the user came from SSO or not.
                if ($scope.registrationData.wasSsoProvisioned) {
                    // For SSO-Provisioned Users.
                    if (_.isArray(allowRule)) {
                        // It depends on your ssoAffiliation.
                        var disallowed = [];
                        var allowed = [];
                        for (var i = 0; i < allowRule.length; i++) {
                            var allowRuleItem = allowRule[i];
                            if (allowRuleItem.substr(0, 1) === '-') {
                                // This is a prohibited affiliation.
                                disallowed.push(allowRuleItem.substr(1));
                            } else {
                                allowed.push(allowRuleItem);
                            }
                        }

                        if (disallowed.length > 0) {
                            // There prohibited affiliations.
                            if (_.contains(disallowed, affiliation)) {
                                return false;
                            }
                        }
                        if (allowed.length > 0) {
                            // There are allowed items. At this point, the user didn't match a disallowed affiliation,
                            // so their admittance is determined only by whether they appear with an allowed one.
                            return _.contains(allowed, affiliation);
                        }
                    } else if (_.isBoolean(allowRule)) {
                        return allowRule;
                    }
                } else {
                    return fallback;
                }
            };

            // Check whitelabel settings for Expert and Consumer.
            if (canRegisterExpert === null) {
                canRegisterExpert = canRegisterLogic(
                    $scope.registrationSettings.WhitelabelSettings.allowRegistrationExpertSso,
                    $scope.registrationSettings.WhitelabelSettings.allowRegistrationExpert);
            }
            if (canRegisterConsumer === null) {
                canRegisterConsumer = canRegisterLogic(
                    $scope.registrationSettings.WhitelabelSettings.allowRegistrationConsumerSso,
                    $scope.registrationSettings.WhitelabelSettings.allowRegistrationConsumer);
            }

            // Override "both" logic if one of your roles is completed; don't go through that process again.
            if (canRegisterConsumer && canRegisterExpert === false) {
                $scope.canChoosePrimaryRole = false;

                if (!$scope.registrationData.primaryRole) {
                    // Skip the step.
                    $scope.registrationData.primaryRole = RegistrationData.ROLE_CONSUMER;
                }
            } else if (canRegisterExpert && canRegisterConsumer === false) {
                $scope.canChoosePrimaryRole = false;

                if (!$scope.registrationData.primaryRole) {
                    $scope.registrationData.primaryRole = RegistrationData.ROLE_EXPERT;
                }
            } else if (canRegisterExpert === false && canRegisterConsumer === false) {
                // You, basically, have completed registration for whatever role[s] you had access to. We're not
                // going to touch your primary role, but you're stuck with whatever you had.
                $scope.canChoosePrimaryRole = false;
            }
            
            if (view) {
                // load the state's controller with our scope
                $controller(view, {$scope: $scope});
            }

            // notify the app that we're ready
            $scope.$emit('controllerLoaded', true);
        });

        /**
         * This function will use the stepGroups to determine what the previous route was
         * and then point the location there
         */
        $rootScope.goToPreviousStep = function() {
            $scope.registrationData.set('progressDirection', -1);

            if ($scope.localSubStep > 0) {
                return gotoGroup($scope.currentStepGroup, $scope.localStep, $scope.localSubStep - 1);
            }

            if ($scope.localStep > 0) {
                // go to next step
                return gotoGroup($scope.currentStepGroup, $scope.localStep - 1);
            } else {
                const prevGroupIndex = _.indexOf(GROUPS, $scope.currentStepGroup) - 1;
                let prevGroup = GROUPS[prevGroupIndex];

                // if this is an expert step and we're consumers...
                if ((prevGroup === 'professional_info' || prevGroup === 'availability')
                    && $scope.registrationData.primaryRole === 'consumer') {
                    // we skip the expert steps
                    prevGroup = 'personal_info';
                }

                // if they're expert only and heading towards the career_goals or confirm page
                if ((prevGroup === 'career_goals' || prevGroup === 'confirm')
                    && $scope.registrationData.primaryRole === 'expert') {
                    prevGroup = 'availability';
                }
                if (prevGroup < 0) {
                    // we're at the start of registration, don't do anything
                } else {
                    // go to the prev step group (we pass -1 so it knows to start at its last step)
                    return gotoGroup(prevGroup, -1);
                }
            }
        };

        function currentStepRequiresVerifiedEmail() {
            if ($scope.currentStepGroup === GROUPS[0] || $scope.currentStepGroup === GROUPS[7]) {
                // getting_started and verify_email do not require verified email.
                return false;
            }
            if ($scope.currentStepGroup === GROUPS[1] && $scope.localStep < 2) {
                // personal_info does not require verified email until step 2 or more.
                return false;
            }

            // Everything else does.
            return true;
        }

        function nextStepAfterSave() {
            $scope.isSavingData = false;
            $scope.registrationData.set('progressDirection', 1);

            if ($scope.registrationData.User.hasVerifiedEmail === false && currentStepRequiresVerifiedEmail()) {
                // Move to the hasVerifiedEmail blocker step.
                $location.path('/verify_email');
                return;
            }

            if ($scope.registrationData.calloutNewProgramName && $scope.registrationData.roleStatus($scope.registrationData.primaryRole) === RegistrationData.STATUS_ACTIVE) {
                // Has a new program being added [in addition to a previous], and their status is already complete. Skip them ahead.
                $location.path('/new_program_added');
                return;
            }

            if ($scope.localStep < $scope.finalStep) {
                // go to next step
                return gotoGroup($scope.currentStepGroup, $scope.localStep + 1);
            } else {
                const nextGroupIndex = _.indexOf(GROUPS, $scope.currentStepGroup) + 1;
                let nextGroup = GROUPS[nextGroupIndex];

                // if this is an expert step and we're consumers...
                if ((nextGroup === 'professional_info' || nextGroup === 'availability')
                    && $scope.registrationData.primaryRole === 'consumer') {
                    // we skip the expert steps
                    nextGroup = 'career_goals';
                }

                if (nextGroup === 'confirm' && $scope.whitelabelling.settings['registrationReplaceConfirmWithComplete'] === true) {
                    nextGroup = 'complete';
                }

                // if they're expert only and heading towards the career_goals or confirm page
                if ((nextGroup === 'career_goals' || nextGroup === 'confirm')
                    && $scope.registrationData.primaryRole === 'expert') {
                    nextGroup = 'complete';
                }

                if (nextGroup === 'complete' && $scope.whitelabelling.settings['hideStep:complete'] === true) {
                    RegistrationService.registrationComplete();

                    return;
                }

                // go to the next step group
                return gotoGroup(nextGroup);
            }
        }

        /**
         * This function will use the stepGroups to determine what the next route is
         * and then point the location there
         */
        $rootScope.goToNextStep = function(skipSave) {
            // if we already have a user with user id, we want to save after each step
            // the step of actually creating the user is going to occur in the PersonalInfo substep
            if (!skipSave && $scope.registrationData.get('User').id) {
                $scope.isSavingData = true;
                $scope.registrationData.set('lastCompletedStep', $location.path());
                $scope.registrationData.CustomInputs = $scope.registrationData.CustomInputs || {file: {}};
                const filesMap = $scope.registrationData.CustomInputs.file; // fileMap will be filled with new files
                CustomInputService
                    .uploadCustomInputResponseFiles($scope.customInputFilesToAdd, filesMap)
                    .then($rootScope.saveRegistrationData);
            } else {
                nextStepAfterSave();
            }
        };

        $rootScope.saveRegistrationData = function() {
            $q.when($scope.registrationData.save()).then(nextStepAfterSave, function(responseObj) {
                if (responseObj.status === 401) {
                    // something got fudged up, they need to login again
                    $window.location.href = '/registration';
                }
            });
        };

        // NOTE: go to previous sub step is accounted for in goToPreviousStep
        $rootScope.goToNextSubStep = function() {
            gotoGroup($scope.currentStepGroup, $scope.localStep, $scope.localSubStep + 1);
        };

        $rootScope.skipThisStep = function() {
            if ($scope.registrationData.get('progressDirection') === 1) {
                $scope.goToNextStep(true);
            } else if ($scope.registrationData.get('progressDirection') === -1) {
                $scope.goToPreviousStep();
            }
        };

        // if the next button appears (the sub group is ready to advance)
        // we check if that step should be auto-advancing. If it should,
        // we auto trigger GoToNext
        $scope.$watch('showNext', function(newVal, oldVal) {
            if (newVal && !oldVal && $scope.autoAdvance) {
                $scope.goToNextStep();
            }
        });

        $scope.$on('goToNextStep', $scope.goToNextStep);
        $scope.$on('goToNextSubStep', $scope.goToNextSubStep);
        $scope.$on('goToPreviousStep', $scope.goToPreviousStep);

        // NOTE: you can only go to a substep if you also specify a step
        function gotoGroup(group, step, substep) {
            let path = '/' + group + (Number.isInteger(step) ? ('/' + step + (Number.isInteger(substep) ? ('/' + substep) : '')) : '');
            $location.path(path);
        }
    },
];
